import styled from "styled-components";
import { Paper, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import pages from "../../constants/pages";
import LOGO from "../../assets/IDA_Logo.svg";
import { PrimaryButton } from "../../pages/css components/Button";
import { signOutMember } from "../../redux/slices/memberSlice";
import ENV from "../../config/config";

const Wrapper = styled(Paper)`
  min-height: 50px;
  border-radius: 0px;
  background: #fff;
  padding: 3px;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
  padding-inline: 10px;
  gap: 6px;
`;

const ImageDiv = styled.div`
  width: 50px;
  height: 40px;
  margin-left: 18px;
`;

const Image = styled.img`
  height: inherit;
  width: inherit;
`;

export default function Navbar({ setSelectedMenu }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const uiDetails = useSelector((state) => state.renderUIDetails);

  const { dashboardPermissions } = useSelector((state) => state.memberDetails);

  return (
    <Wrapper elevation={2}>
      <GridContainer container>
        <Grid
          item
          alignSelf={"center"}
          textAlign={"center"}
          style={{ cursor: "pointer" }}
        >
          <ImageDiv
            onClick={() => {
              const isAdminBrand = dashboardPermissions.some(
                (page) => page.ID === "administrator-brands"
              );

              const path = isAdminBrand
                ? pages.accountVerification.route
                : pages.brandDetails.route;

              navigate(path);
              setSelectedMenu(path);
            }}
          >
            <Image src={LOGO} alt="!" />
          </ImageDiv>
        </Grid>

        <Grid item xs />

        <Grid item alignSelf={"center"} textAlign={"center"}>
          <PrimaryButton
            style={{ height: "35px", fontSize: "13px" }}
            variant="contained"
            onClick={() => {
              const ida_sso_login = sessionStorage.getItem("ida_sso_login");
              if (ida_sso_login === "true") {
                if (ENV === "main") {
                  window.location = "https://ida.ioh.id/";
                }

                if (ENV === "uat") {
                  window.location = "https://ida-dev.gammasprint.com/";
                }

                if (ENV === "dev") {
                  window.location = "https://ida-dev.gammasprint.com/";
                }
              }

              dispatch(signOutMember());
            }}
          >
            Logout
          </PrimaryButton>
        </Grid>
      </GridContainer>
    </Wrapper>
  );
}
